import { SearchMenuAction } from './types';

export const searchActionMenuSizeByAction: Partial<
  Record<SearchMenuAction, 'large' | 'medium'>
> = {
  'delete-word': 'large',
  'edit-word': 'medium',
};
